(function () {
  document.querySelectorAll('[data-cart-lola]').forEach(function (section) {
    initLines(section);
  });

  // Deliberately simple: this relies on Shopify's native cart form
  // ("updates[variant_id]" fields + a normal POST to /cart) rather than
  // a custom /cart/change.js + manual DOM re-render. Every quantity
  // change or removal just submits the real form and the page reloads
  // with the server's own numbers — a bit less "instant" than a full
  // AJAX cart, but with zero risk of the displayed totals drifting out
  // of sync with what Shopify actually charges, and a lot less code to
  // maintain going forward.
  function initLines(section) {
    var form = section.querySelector('.cart-lola__form');
    if (!form) return;

    var lines = Array.prototype.slice.call(section.querySelectorAll('[data-cart-lola-line]'));

    lines.forEach(function (line) {
      var input = line.querySelector('[data-cart-lola-qty-input]');
      var minusBtn = line.querySelector('[data-cart-lola-qty-minus]');
      var plusBtn = line.querySelector('[data-cart-lola-qty-plus]');
      var removeBtn = line.querySelector('[data-cart-lola-remove]');
      if (!input) return;

      function currentValue() {
        var value = parseInt(input.value, 10);
        return isNaN(value) || value < 0 ? 0 : value;
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          input.value = Math.max(0, currentValue() - 1);
          form.requestSubmit();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          input.value = currentValue() + 1;
          form.requestSubmit();
        });
      }

      input.addEventListener('change', function () {
        input.value = currentValue();
        form.requestSubmit();
      });

      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          input.value = 0;
          form.requestSubmit();
        });
      }
    });
  }
})();
